module.exports = __webpack_public_path__ + "img/1723776788105-image.jpg.19cff8bb.webp";